import { render, staticRenderFns } from "./NestedCategorySelect.vue?vue&type=template&id=267793ad&scoped=true"
import script from "./NestedCategorySelect.vue?vue&type=script&setup=true&lang=js"
export * from "./NestedCategorySelect.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NestedCategorySelect.vue?vue&type=style&index=0&id=267793ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267793ad",
  null
  
)

export default component.exports